import React, { useContext, useEffect } from 'react';
import Sidebar from './Sidebar';
import { Outlet,  } from 'react-router-dom';
import DashboardHeader from './DashboardHeader';
import { UserContext } from '../hook/UserLoginData';
 
const DashboardLayout = () => {
  const { setUser } = useContext(UserContext);
  useEffect(()=>{
    setUser(localStorage.getItem('user'))
  }, [setUser]);
  return (
    <div style={{ backgroundColor: '#E7EEF4',  height: '100%', }}>
      {/* Header and Sidebar */}
      <DashboardHeader/>
      <div className='d-flex' >
      <div
        className="d-flex flex-column p-3"
        style={{
          width: '220px',
          left: '0',
          backgroundColor: '#10216E',
          color: '#fff',
          height:"auto"
        }}
      >
      <Sidebar />
      </div>
      <div className='flex-grow p-4'>
      <Outlet />
      
      </div>
     
      </div>
    </div>
  );
};
 
export default DashboardLayout;